'use client';

import { useBunja } from 'bunja/react';
import { PropsWithChildren } from 'react';

import { DialogLayout } from '@flipster/react/design-system/dialog';
import { SnackbarLayout } from '@flipster/react/design-system/snackbar';

import { useVARARegulationPopup } from '@web/app/[locale]/_user-regulation-popup';
import { rootPopupBunja } from '@web/app/_layout/root-popup';
import AuthRedirect from '@web/components/AuthRedirect';

const Template = ({ children }: PropsWithChildren) => {
  useBunja(rootPopupBunja);
  useVARARegulationPopup();

  return (
    <>
      <DialogLayout />
      <SnackbarLayout />
      <AuthRedirect />

      {children}
    </>
  );
};

export default Template;
